export default "__VITE_ASSET__DZQYISQO__"